import axios from 'axios';
import { SpaError } from '../../redux/models/errorLog.model';

import { BASE_URL as API_BASE_URL } from './apiconfig';

export const getSpaErrorLogs = async (spaId: string): Promise<{ data: SpaError[] }> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/spas/${spaId}/error-logs`);
    return response.data;;
  } catch (error) {
    console.log("Failed to error logs. ", error);
    throw error;
  }
};